export const RESPONSE = {
  CODE: {
    SUCCESS: 200,
    FAIL: 400,
    TOKEN_EXPIRED: 401,
    SERVER_ERROR: 500
  }
}
